import React from 'react';

import { ArrowDropDown, Delete } from '@mui/icons-material';
import { Button, ButtonGroup, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { isNil } from 'lodash';
import { createScopedI18n } from '../../../../i18n/i18n';
import CancelPeriodJobDialog from './cancel_period_job_dialog';

const jobDetailPageI18n = createScopedI18n('pages.jobs_id');

export type PeriodJobActionButtonProps = {
  periodJobId: string;
};

const PeriodJobActionButton = ({ periodJobId }: PeriodJobActionButtonProps) => {
  const [menuAnchor, setMenuAnchor] = React.useState<HTMLElement | null>(null);
  const [showCancelPeriodJobDialog, setShowCancelPeriodJobDialog] = React.useState(false);

  const menuOpenHandler = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };
  const menuCloseHandler = () => setMenuAnchor(null);

  const openCancelPeriodJobDialogHandler = () => {
    menuCloseHandler();
    setShowCancelPeriodJobDialog(true);
  };
  const closeCancelPeriodJobDialogHandler = () => setShowCancelPeriodJobDialog(false);

  return (
    <>
      <ButtonGroup variant="outlined" color="error" disableElevation>
        <Button onClick={openCancelPeriodJobDialogHandler}>{jobDetailPageI18n('cancel_job')}</Button>
        <Button
          size="small"
          onClick={menuOpenHandler}
          sx={{
            minWidth: '40px',
          }}
        >
          <ArrowDropDown />
        </Button>
      </ButtonGroup>

      <Menu
        open={!isNil(menuAnchor)}
        anchorEl={menuAnchor}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={menuCloseHandler}
      >
        <MenuItem onClick={openCancelPeriodJobDialogHandler} sx={{ color: 'error.main' }}>
          <ListItemIcon>
            <Delete fontSize="small" color="error" />
          </ListItemIcon>
          {jobDetailPageI18n('cancel_job')}
        </MenuItem>
      </Menu>

      <CancelPeriodJobDialog
        open={showCancelPeriodJobDialog}
        periodJobId={periodJobId}
        onClose={closeCancelPeriodJobDialogHandler}
      />
    </>
  );
};

export default PeriodJobActionButton;
